const defaultErrMsg = '奖励领取失败，请稍后重试';

export const errors = {
    invalid_param: err => {
        return err || '网络延迟，请再提交一次';
    },
    issue_failed: err => {
        return err || defaultErrMsg;
    },
    create_leads_failed: err => {
        return err || defaultErrMsg;
    },
    invalid_fellow_mobile: err => {
        return err || defaultErrMsg;
    },
    only_one_award_allowed: () => {
        return '奖励已领取，请前往App查看';
    },
    award_group_limit: () => {
        return '您已获得过活动奖励，请前往NIO App查看';
    },
    vc_validation_failed: () => {
        return '验证码输入错误，请重试';
    },
    vc_expired: () => {
        return '验证码已过期，请重新获取';
    },
    vc_validation_failed_times: () => {
        return '验证码输入错误次数过多，请重新获取验证码';
    },
    award_user_not_existence_account: () => {
        return '恭喜你获得奖励，下载NIO App后领取';
    }
};

export function getErrorMsg(errorCode, err) {
    if (!errorCode) return defaultErrMsg;

    const getError = errors[errorCode];
    if (!getError) return defaultErrMsg;

    if (typeof getError === 'string') {
        return getError;
    }

    return getError(err.display_msg || err.message);
}



// WEBPACK FOOTER //
// ./src/views/marketing/components/leads-award/result-code.js